import formatTime from '@anm/helpers/time/formatTime';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import timeToISO from '../../../helpers/timeToISO';
import { templateSelectors } from '../../../store/modules/template';
import {
  selectDefaultTemplateMedia,
  selectMediumSize
} from '../../../store/modules/template/selectors';
import StructuredData, { StructuredDataProps } from '../../StructuredData';

const TemplateVideoObject: FC = () => {
  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);

  if (!currentTemplate) return null;

  const { meta, created, description, displayName } = currentTemplate;

  const { duration } = meta;
  const defaultMedia = selectDefaultTemplateMedia(currentTemplate);
  const thumb = selectMediumSize(defaultMedia.thumb);
  const embedUrl = selectMediumSize(defaultMedia.video).url;
  const ISODuration = timeToISO(formatTime(duration));
  const videoObjectProps: StructuredDataProps = {
    embedUrl,
    description,
    name: displayName,
    duration: ISODuration,
    uploadDate: new Date(created).toISOString(),
    thumbnailUrl: [thumb.url]
  };

  return <StructuredData {...videoObjectProps} />;
};

export default TemplateVideoObject;
